import { FC, Fragment } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Types
import QuizTypes from 'types/QuizTypes';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz, selectQuestionsLength } from 'store/quiz/quizSelectors';
import { selectQuestionReady, selectCurrentQuestionIndex } from 'store/player/playerSelectors';

type Props = {
  score: number;
  width: number;
}

const QuestionScoringBar:FC<Props> = ({ score, width }) => {
  const { t } = useTranslation();
  // State
  const quiz:IQuiz = useAppSelector(selectQuiz);
  const questionsLength:number = useAppSelector(selectQuestionsLength);
  const questionReady:boolean = useAppSelector(selectQuestionReady);
  const currentQuestionIndex = useAppSelector(selectCurrentQuestionIndex);

  if ( [QuizTypes.Personality, QuizTypes.Poll, QuizTypes.RankingPoll].includes(quiz.type) ) return null;
  if ( !questionReady ) return null;
  return (
    <div
      className="
        absolute right-0 bottom-0 left-0
        flex items-end gap-3
        bg-gradient-to-t from-black to-transparent
        pt-4 px-3 pb-2
      "
    >
      <span className="text-white text-sm font-bold">
        {currentQuestionIndex}&nbsp;/&nbsp;{questionsLength}
      </span>
      {quiz.questionsSettings.timeout && (
        <Fragment>
          <div
            className="relative w-full bg-gray-200 border-4 border-gray-200 h-4 rounded-lg"
            style={{ marginBottom: 2 }}
          >
            <div className="absolute top-0 left-0 w-full h-2 opacity-25 rounded-lg z-0" style={{ backgroundColor: quiz.theme.progressBarColor }}></div>
            <div className="absolute top-0 left-0 h-2 rounded-lg z-10" style={{ width: `${width}%`, backgroundColor: quiz.theme.progressBarColor }}></div>
          </div>
          <div className="flex flex-col text-white w-12">
            <span className="text-xss leading-4 text-center">{t('labels.score')}</span>
            <span className="text-sm leading-4 text-center font-bold">{score}</span>
          </div>
        </Fragment>
      )}
    </div>
  )
}

export default QuestionScoringBar;
